import { format, isBefore, isValid, parseISO, startOfDay } from 'date-fns'

export const TIMELINE_SIDEBAR_DATE_DISPLAY_FORMAT = 'yy.MM.dd'

const compactDateInputClassName =
  'box-border block h-9 rounded-md border border-rb-widget-border bg-white px-2 text-center text-sm leading-9 dark:border-rb-dark-mode-lighter dark:bg-rb-dark-mode'

export const timelineSidebarCompactDateInputClassName = compactDateInputClassName

/** Reserved width/height for the inline date pair so row height stays stable when duration is toggled off */
export const timelineSidebarDateFieldWidthClass = 'w-[5.25rem] shrink-0'

export const timelineSidebarDateSlotClassName =
  'flex h-9 shrink-0 items-center gap-1.5'

export function parseTimelineDateValue(value) {
  if (!value) return null
  const parsed = typeof value === 'string' ? parseISO(value.split('T')[0]) : new Date(value)
  return isValid(parsed) ? parsed : null
}

export function formatTimelineDateForInput(value) {
  const parsed = parseTimelineDateValue(value)
  return parsed ? format(parsed, 'yyyy-MM-dd') : ''
}

export function formatTimelineDateShort(value) {
  const parsed = parseTimelineDateValue(value)
  return parsed ? format(parsed, TIMELINE_SIDEBAR_DATE_DISPLAY_FORMAT) : ''
}

export function isDateOutsideCampaignPeriod(dateValue, campaignStartDate, campaignEndDate) {
  if (!dateValue) return false
  if (campaignStartDate && dateValue < campaignStartDate) return true
  if (campaignEndDate && dateValue > campaignEndDate) return true
  return false
}

export function isTimelineEndDatePassed(endDateValue) {
  const endDate = parseTimelineDateValue(endDateValue)
  if (!endDate) return false

  return isBefore(endDate, startOfDay(new Date()))
}
